
export const SET_READY_TO_SUBMIT_RESCUE = "SET_READY_TO_SUBMIT_RESCUE";
export const SET_READY_TO_SUBMIT_RESCUE_SUCCESS = "SET_READY_TO_SUBMIT_RESCUE_SUCCESS";

export interface SetReadyToSubmitRescueAction {
  type: typeof SET_READY_TO_SUBMIT_RESCUE;
  payload: boolean;
}

export interface SetReadyToSubmitRescueSuccessAction {
  type: typeof SET_READY_TO_SUBMIT_RESCUE_SUCCESS;
  payload: boolean;
}

export const setReadyToSubmitRescue = (value: boolean) => ({
  type: SET_READY_TO_SUBMIT_RESCUE,
  payload: value
});

export const setReadyToSubmitRescueSuccess = (value: boolean) => ({
  type: SET_READY_TO_SUBMIT_RESCUE_SUCCESS,
  payload: value
});

export type ReadyToSubmitRescueActions =
  | ReturnType<typeof setReadyToSubmitRescue>
  | ReturnType<typeof setReadyToSubmitRescueSuccess>;